import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card border-0 rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8 col-xxl-8 col-sm-12 p-0" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "table" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col-md-4 col-xxl-4 col-sm-12 p-0" }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_19 = { class: "carousel-inner" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "text-black fw-semibold" }, "Détails d'un produit", -1)),
        _createVNode(_component_router_link, {
          to: "/produits/liste-produits",
          class: "btn btn-primary text-black transition border-0 lh-1 fw-medium",
          style: {"position":"absolute","right":"10px","top":"10px"}
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1" }, null, -1),
            _createTextVNode(" Retour ")
          ])),
          _: 1
        })
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Informations générales", -1)),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, "Code Produit", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.produit?.codeProduit), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[3] || (_cache[3] = _createElementVNode("td", null, "Référence", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.produit?.refProd), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Famille", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.produit?.famille?.libelleFamille), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Nom", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.produit?.nomProd), 1)
              ]),
              (_ctx.produit?.uniteGestion)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Unité de gestion:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.uniteGestion?.libelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.produit?.uniteStock)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Unité de Stock:", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.produit?.uniteStock?.libelle), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.produit?.descProd)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Description du produit", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.produit?.descProd), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col" }, [
              _createElementVNode("h5", { class: "text-black fw-bold mt-4" }, "Conditionnements du produit")
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: { name: 'AddProduitConditionnement', params: { id: _ctx.produit?.id } },
                class: "btn btn-primary text-black mt-3 text-center"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "fa fa-plus-circle lh-2 me-8 position-relative top-1" }, null, -1),
                  _createTextVNode(" Compléter un conditionnement ")
                ])),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("table", _hoisted_12, [
            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Conditionnement"),
                _createElementVNode("th", null, "Qté Condit."),
                _createElementVNode("th", null, "UM"),
                _createElementVNode("th", null, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produit?.produitconditionnements, (produitconditionnement, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(produitconditionnement.conditionnement?.libelle), 1),
                  _createElementVNode("td", null, _toDisplayString(produitconditionnement.qteCond), 1),
                  _createElementVNode("td", null, _toDisplayString(produitconditionnement.conditionnement2?.libelle), 1),
                  _createElementVNode("td", null, [
                    (index !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, [
                            _createElementVNode("a", {
                              class: "bullet me-3 btn f-w-500 background-light-danger font-danger",
                              href: "javascript:void(0);",
                              onClick: ($event: any) => (_ctx.suppression(produitconditionnement.id, _ctx.produit?.produitconditionnements, 'produitconditionnement', `le conditionnement ${produitconditionnement.conditionnement.libelle}`))
                            }, _cache[11] || (_cache[11] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-2 me-8 position-relative top-1" }, null, -1)
                            ]), 8, _hoisted_15)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[15] || (_cache[15] = _createElementVNode("h5", { class: "text-black fw-bold mb-10" }, "Image du Produit", -1)),
          _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1)),
          (_ctx.produit?.imagePrincipal)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.getUrlApiForProductFiles(_ctx.produit?.imagePrincipal),
                class: "d-block w-100",
                alt: "Photo"
              }, null, 8, _hoisted_17))
            : _createCommentVNode("", true),
          _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
          (_ctx.medias.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["carousel-item", index == 0 ? 'active' : '']),
                      key: index
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.getUrlApiForProductFiles(media.nomMedia),
                        class: "d-block w-100",
                        alt: "Photo"
                      }, null, 8, _hoisted_20)
                    ], 2))
                  }), 128))
                ]),
                _cache[14] || (_cache[14] = _createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"prev\" data-v-5e2918f0><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\" data-v-5e2918f0></span><span class=\"visually-hidden\" data-v-5e2918f0>Précédent</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide=\"next\" data-v-5e2918f0><span class=\"carousel-control-next-icon\" aria-hidden=\"true\" data-v-5e2918f0></span><span class=\"visually-hidden\" data-v-5e2918f0>Suivant</span></button>", 2))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: _ctx.getUrlApiForProductFiles(null),
                  class: "d-block w-100",
                  alt: "Photo"
                }, null, 8, _hoisted_22)
              ]))
        ])
      ])
    ])
  ]))
}